export default __webpack_public_path__ + "static/media/car_engine.f8b1878a.png";